const Colors = {
    antzcodeDarkBlue: '#01042e',
    antzcodeBrightBlue: '#0b69c8',
    antzcodeBackgroundBlue: '#121537',
    antzcodeBorderBlue: '#7692a6',
    antzcodeWhite: '#dadada',
};

export default Colors;
